import { createRouter, createWebHistory } from 'vue-router';

// Pages
import Index from '@/pages/Index.vue';
import NewConfiguration from '@/pages/NewConfiguration.vue';
import Configurator from '@/pages/Configurator.vue';
import P404 from '@/pages/404.vue';

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      component: Index,
      name: 'Index',
    },
    {
      path: '/new-configuration',
      component: NewConfiguration,
      name: 'NewConfiguration',
    },
    {
      path: '/configurator',
      component: Configurator,
      name: 'Configurator',
    },
    {
      path: '/:catchAll(.*)',
      component: P404,
      name: '404',
    },
  ],
});

export default router;
